export default "__VITE_ASSET__2dXq$DBr__"